import Fuse from 'fuse.js';
import isEqual from 'lodash.isequal';
import { useEffect, useRef, useState } from 'react';

export interface FuzzySearchConfig<T> {
  list: T[];
  options?: Fuse.IFuseOptions<any>;
  term?: string;
}

export const useFuzzySearch = <T>({ list, options, term }: FuzzySearchConfig<T>) => {
  const [query, setQuery] = useState<string | undefined>(() => {
    if (term) return term;
    return undefined;
  });
  const [results, setResults] = useState<T[]>(list);

  const fuseRef = useRef<Fuse<any, any>>();

  useEffect(() => {
    fuseRef.current = new Fuse(list, options);
  }, [list, options]);

  useEffect(() => {
    if (!(fuseRef && fuseRef.current)) {
      return;
    }

    const newResults = query ? fuseRef.current.search(query).map(({ item }: any) => item) : list;
    if (isEqual(results, newResults)) {
      return;
    }

    setResults(newResults);
  }, [list, results, query]);

  return {
    results,
    query,
    setQuery,
  };
};
